import { cache } from "react"
import { About } from "@/types/getAbout"
import directusServer from "./directus/directusGraphQLInstance"
import { rethrowIfDatabaseUnavailable } from "./errors/database"

const getAbout = cache(async () => {
  try {
    const response = await directusServer.query<About>(`
    query getAbout {
      webpage_config {
        about_description
        location
        portrait_image {
					id
					width
					height
					filename_download
				}
        portrait_image_hover {
					id
					width
					height
					filename_download
				}
        cv_file {
					id
				}
      }
      skills(
					sort:  "name"
				) {
        id,
				status
        slug
        name
        svg_logo
        svg_color_icon
        icon_color
        description
        area
      }
      experience(sort: "-start_date", filter: { status: { _eq: "published" } }) {
        id
        job_title
        start_date
        end_date
        company {
          id
          name
          url
          svg_logo
        }
        description
        location
        job_type
        remote
        consulting_projects (
          sort: "-start_date"
          filter: { status: { _eq: "published" } }
        ) {
          id
          title
          start_date
          end_Date
          role
          description
          location
          skills {
            skills_id (
              sort: "-name"
              filter: { status: { _eq: "published" } }
            ) {
              name
              slug
              icon_color
              svg_logo
              }
            }
            company (
              sort: "-name"
              filter: { active: { _eq: true } }
            ) {
              name
              slug
              url
              svg_logo
            }
          }
        }
        education(sort: "-start_date", filter: { status: { _eq: "published" } }) {
        id
        course_name
        start_date
        end_date
        location
        company {
          id
          name
          url
          svg_logo
        }
        role_description
        education_type
      }
    }
    `)

    return response
  } catch (error) {
    rethrowIfDatabaseUnavailable(error)
    console.error(error)
    return null
  }
})

export default getAbout
